import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import { Link, Redirect } from 'react-router-dom'
import { defineMessages, FormattedDate, FormattedMessage, FormattedNumber, injectIntl } from 'react-intl'
import StandardList from '../common/listing/list.component.jsx'
import SideBar from '../common/layout/sidebar.component.jsx'
import LoadingSpinner from '../common/spinner/loading.component.jsx'
import NoResult from "../common/listing/noresult.component.jsx";
import GlobalHelper from "../common/GlobalHelper";
import SortLink from "../common/listing/sortlink.component";
import InvoicesTabs from "../common/layout/tabs/invoices.component";
import Pagination from "../common/listing/pagination.component";
import Search from "../common/search-filter/search/search.component";
import Document from "../common/document/document.component";
import Icon from "../common/icon/icon.component.jsx";
import ActionButton from "../common/button/actionbutton.component.jsx";
import {SORT_BY_FIELD} from "../utils"

const messages = defineMessages({
    "search_placeholder": {
        id: 'invoice.listing.search_placeholder_receipt',
        defaultMessage: 'Search an receipt...',
    },
})

class ReceiptsListing extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            headers: [],
            rows: [],
            footer: [],
            searchKeywords: '',
            activePage: 1,
            pageSize: 10,
            totalItemsCount: 0,
            loading: true,
            sortField: SORT_BY_FIELD.IDENTIFIER,
            asc: false,
            objects: ['external-orders'],
            data: '',
            filtersToUse: {},
            prefLoaded: false,
            savedFilterId: '',
            rowsButtonLoadingMap: {},
        }

        this.initSearchComponent = this.initSearchComponent.bind(this)
        this.handlePageChange = this.handlePageChange.bind(this)
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this)
        this.handleSortLinkChange = this.handleSortLinkChange.bind(this)
        this.updateListing = this.updateListing.bind(this)
        this.savePref = this.savePref.bind(this)
        this.refreshSearch = this.refreshSearch.bind(this)
    }

    componentDidMount() {
        GlobalHelper.getListingPreferences('listingExternalOrders', false).then(pref => {
            this.setState({
                activePage: pref.page || 1,
                pageSize: pref.pageSize || 10,
                searchKeywords: pref.keywords || '',
                sortField: pref.sortField || SORT_BY_FIELD.IDENTIFIER,
                asc: pref.asc || false,
                filtersToUse: pref.filters || {},
                savedFilterId: pref.savedFilterId || '',
            }, () => this.initSearchComponent())
        }, () => this.initSearchComponent())

        SideBar.activateMenu('invoice')
    }

    initSearchComponent() {
        this.setState({ prefLoaded: true })
    }

    handlePageChange(pageNumber) {
        this.setState({
            activePage: pageNumber
        }, () =>
            this.updateListing(true, false, this.state.data)
        )
    }

    handleSortLinkChange(sortField, asc) {
        this.setState({
            sortField: sortField,
            asc: asc,
        }, () => {
            this.updateListing(true, false, this.state.data)
        })
    }

    handlePageSizeChange(size) {
        this.setState({
            pageSize: size,
            activePage: 1,
        }, () =>
            this.updateListing(true, false, this.state.data)
        )
    }

    savePref() {
        return GlobalHelper.saveListingPreferences(
            'listingExternalOrders',
            this.state.activePage,
            this.state.pageSize,
            this.state.searchKeywords,
            "",
            false,
            false,
            this.state.sortField,
            this.state.asc,
            this.state.filtersToUse,
            this.state.savedFilterId,
        )
    }


    updateListing(savePref, refreshTotal, data) {
        this.setState({
            loading: true,
        })
        let newData = Object.assign(data);
        newData['pageSize'] = this.state.pageSize
        newData['activePage'] = this.state.activePage
        newData['sortAsc'] = this.state.asc
        newData['sortByField'] = this.state.sortField
        Promise.all([
            AppContext.getApiClient().post('/listing/search', newData)
        ]).then(res => {
            const r = res[0]
            this.setState({
                data: newData,
                headers: r.data.length > 0 ? this.headers() : [],
                rows: r.data.map(q => this.row(q)),
                totalItemsCount: r.metadata.totalItemsCount,
                loading: false,
            })
        })
        if (refreshTotal) {
            newData['totals'] = ['totalAmount']
            AppContext.getApiClient().post('/listing/search-totals', newData).then(res => {
                this.setState({
                    footer: this.footer(res)
                })
            })
        }
        if (savePref) {
            this.savePref()
        }

    }

    headers() {
        let headers = [
            <SortLink
                field={SORT_BY_FIELD.IDENTIFIER}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="invoice.lightspeed_listing.receipt_header_id"
                    defaultMessage="ID"
                />
            </SortLink>,
            <SortLink
                field={'createdAt'}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="invoice.lightspeed_listing.header_date"
                    defaultMessage="Creation Date"
                />
            </SortLink>,
            <SortLink
                field={'totalAmount'}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="invoice.listing.headers.amount_label"
                    defaultMessage="Amount"
                />
            </SortLink>,
            <SortLink
                field={'externalId'}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="invoice.listing.headers.external_id_label"
                    defaultMessage="External ID"
                />
            </SortLink>,
            <FormattedMessage
                id="invoice.listing.headers.receipt"
                defaultMessage="Receipt"
            />
        ]
        let classNames = ['', '', '', '', 'text-center']

        return {
            classNames: classNames,
            data: headers,
        }
    }

    renderQRCodeButtons(externalOrder) {
        const buttonClickHandler = (endpoint, timeoutSeconds) => {
            this.setState({
                rowsButtonLoadingMap: { ...this.state.rowsButtonLoadingMap, ...{ [externalOrder.id]: true } }
            })
            AppContext.getApiClient().post(endpoint, {})
                .then(res => {
                    setTimeout(() => {
                        this.setState({
                            rowsButtonLoadingMap: { ...this.state.rowsButtonLoadingMap, ...{ [externalOrder.id]: false } },
                        }, () => {
                            this.updateListing(true, false, this.state.data)
                        })
                    }, timeoutSeconds)
                })
        }

        if (!externalOrder.qrCodeImage) {
            return <ActionButton
                className="btn btn-primary"
                onClick={() => {
                    buttonClickHandler(`/external-orders/${externalOrder.id}/generate-qr-code`, 2500)
                }}
                isLoading={this.state.rowsButtonLoadingMap[externalOrder.id]}>
                <Icon value={'qrcode'} className={'mr-1'} />
                <FormattedMessage
                    id="invoice.receipts_listing.generate_qr_code.label"
                    defaultMessage="Generate QR Code"
                />
            </ActionButton>
        }
        if (externalOrder.qrCodeImage && !externalOrder.pdfReceiptFileId) {
            return <ActionButton
                className="btn btn-primary"
                onClick={() => {
                    buttonClickHandler(`/external-orders/${externalOrder.id}/generate-pdf`, 6000)
                }}
                isLoading={this.state.rowsButtonLoadingMap[externalOrder.id]}>
                <Icon value={'file-pdf'} className={'mr-1'} />
                <FormattedMessage
                    id="invoice.receipts_listing.generate_pdf.label"
                    defaultMessage="Generate PDF"
                />
            </ActionButton>
        } else if (externalOrder.pdfReceiptFileId) {
            return <Document
                extension={'pdf'}
                name={'Open PDF'}
                hideFileName={true}
                documentId={externalOrder.pdfReceiptFileId}
            />
        }

        return ''
    }

    row(externalOrder) {
        const rows = [
            externalOrder.identifier,
            externalOrder.createdAt ?
                <FormattedDate
                    year='numeric'
                    month='long'
                    day='numeric'
                    value={new Date(externalOrder.createdAt)}
                /> : '-',
            <FormattedNumber
                style="currency"
                currency={externalOrder.currency}
                value={externalOrder.totalAmount}
            />,
            externalOrder.externalId,
            this.renderQRCodeButtons(externalOrder)
        ]

        const classNames = ['', '', '', '', 'text-center']
        return {
            classNames: classNames,
            rowId: externalOrder.id,
            data: rows,
        }
    }

    refreshSearch(savePrefs, refreshTotal, refreshStatBox, data, filtersToUse, searchKeywords, savedFilterId) {
        if (savePrefs) {
            this.setState({
                data: data,
                searchKeywords: searchKeywords,
                filtersToUse: filtersToUse,
                activePage: 1,
                loading: false,
                savedFilterId: savedFilterId
            },
                () => {
                    this.updateListing(savePrefs, refreshTotal, data)
                })

        } else {
            this.updateListing(savePrefs, refreshTotal, data)
        }
    }

    footer(totals) {
        let rows = [
            <strong>
                <FormattedMessage
                    id="invoice.listing.headers.totals_label"
                    defaultMessage="Totals"
                />
            </strong>,
            <strong>{totals.attributes.totalItemsCount}</strong>,
            <FormattedNumber
                style="currency"
                currency={AppContext.getAccount().attributes.currency}
                value={totals.attributes.totals.totalAmount}
            />,
            '',
            '',
        ]
        let classNames = ['', '', '', '', '']

        return {
            classNames: classNames,
            data: rows,
        }
    }

    render() {
        if (AppContext.getAccount().attributes.onBoardingStatus === "pending") {
            return <Redirect to={{ pathname: '/' }} />
        }

        let list = <StandardList
            smallLine={true}
            className="row pt-3"
            headers={this.state.headers}
            rows={this.state.rows}
            footer={this.state.footer}
            footerClassName={'bg-secondary text-white'}
            searchData={this.state.data}
            pageSize={this.state.pageSize}
            totalItemsCount={this.state.totalItemsCount}
            selectable={false}
        />

        if (this.state.loading) {
            list = <LoadingSpinner />
        } else if (this.state.rows.length === 0) {
            list = <NoResult noButton={true} />
        }

        return (
            <div>
                <InvoicesTabs />
                <Search
                    onChange={this.refreshSearch}
                    key="searchExternalOrders"
                    typeOfSearch="externalOrders"
                    searchBarClass={"col-md-6"}
                    childrenClass={"col-md-2"}
                    searchKeywords={this.state.searchKeywords}
                    filtersToUse={this.state.filtersToUse}
                    object={this.state.objects}
                    placeholder={this.props.intl.formatMessage(messages["search_placeholder"])}
                    savedFilterId={this.state.savedFilterId}
                />
                {list}
                <Pagination
                    showPageSize={true}
                    onChange={this.handlePageChange}
                    onPageSizeChange={this.handlePageSizeChange}
                    activePage={this.state.activePage}
                    pageSize={this.state.pageSize}
                    totalItemsCount={this.state.totalItemsCount}
                >
                </Pagination>
            </div>
        );
    }
}

export default injectIntl(ReceiptsListing)



// WEBPACK FOOTER //
// ./src/invoice/receiptsListingComponent.jsx